import { Link } from 'react-router-dom';
import { ShieldCheck } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { useT } from '@/i18n';

/**
 * F5-R1a — superficie del agente (solo agents la renderizan: admin/sup/
 * uploader/navigator redirigen en HomeOrRoleRedirect), re-vestida al brand:
 * títulos Montserrat, tarjetas blancas borde nav-card, acentos teal. Misma
 * estructura y navegación; muere el ui/Card lavender.
 */
export function HomePage(): JSX.Element {
  const t = useT();
  const user = useAuthStore((s) => s.user);
  const firstName = user ? user.fullName.split(' ')[0] : '';

  return (
    <div className="space-y-8 font-body text-nav-navy">
      <div>
        <h1 className="font-head text-3xl font-extrabold tracking-[-0.02em] leading-tight">
          {firstName ? t('home.welcomeWithName', { name: firstName }) : t('home.welcome')}
        </h1>
        <p className="text-nav-slate mt-1.5 text-base">
          {user?.role === 'agent' ? t('home.taglineAgent') : t('home.taglineGeneric')}
        </p>
      </div>

      <div className="grid gap-4 sm:grid-cols-2 max-w-3xl">
        {/* F5-R9a: murió el bloque agent-only de la tarjeta «Mi cola» —
            era código muerto: HomeOrRoleRedirect nunca renderiza HomePage
            para agents (renderiza InicioPage, donde la cola vive ahora). */}
        {(user?.role === 'admin' || user?.role === 'supervisor') && (
          <Link
            to="/admin"
            className="group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-nav-teal rounded-xl"
          >
            <div className="h-full bg-white border-[1.5px] border-nav-card rounded-xl px-5 py-5 transition-all duration-[180ms] hover:border-nav-teal hover:-translate-y-[2px] motion-reduce:hover:translate-y-0">
              <div className="flex items-start gap-3">
                <div className="h-11 w-11 rounded-[10px] bg-nav-tealTint flex items-center justify-center shrink-0">
                  <ShieldCheck className="h-5 w-5 text-nav-tealDark" />
                </div>
                <div>
                  <p className="font-head text-lg font-bold m-0">{t('home.adminCardTitle')}</p>
                  <p className="text-sm text-nav-slate mt-0.5 m-0">{t('home.adminCardDesc')}</p>
                </div>
              </div>
              <p className="font-head text-xs font-semibold text-nav-teal mt-4 m-0">{t('home.adminCardHint')}</p>
            </div>
          </Link>
        )}
      </div>
    </div>
  );
}
